import React, {Component} from 'react';
import {connect} from 'react-redux';
import {RootState, selectors} from '../store';
import {
  IonPopover,
  IonIcon,
  IonSelect,
  IonSelectOption,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonMenuButton,
  IonContent,
  IonList,
  IonItem,
  IonLabel,
  IonDatetime,
  IonTitle,
  IonBackButton,
  IonInput,
  IonRow,
  IonCol,
  IonPage,
  IonFooter,
  IonTextarea,
  IonToggle,
  IonListHeader,
} from '@ionic/react';
import './Studentcurriculumstop.css';
import AboutPopover from '../components/AboutPopover';
import {calendar, pin} from 'ionicons/icons';
import {RouteComponentProps} from "react-router";
import {AuthComponent} from "./_/AuthComponent";
import _ from "../_";
import {ApiService} from "../_/ApiService";
import {Static} from "../_/Static";
import {StaticEvent} from "../_/StaticEvent";

type Props = RouteComponentProps<{}> & ReturnType<typeof mapStateToProps>

type State = {
  showPopover: boolean,
  showPopoverEvent: null | MouseEvent,

  _userData: any,
  pageData: any,
  Item_對象: any,
}

class Studentcurriculumstop extends AuthComponent<Props, State> {
  static RoutePathname = /^\/studentcurriculumstop\/[^/]+/gi;

  constructor(props: Props) {
    super(props);

    this.state = {
      showPopover: false,
      showPopoverEvent: null,

      _userData: null,
      pageData: null,
      Item_對象: {},
    };


  }

  async componentDidMount() {
    await super.componentDidMount();

    //必須要引用 AuthComponent, 才能在這裡拿取用戶資料
    //若是引用 BaseComponent 則不需要下面
    // @ts-ignore
    this.setState({
      _userData: this._userData,
    });
  }

  async afterEventsLoader() {
    window.setTimeout(() => {
      const myPathname = this.props.location.pathname;
      if (myPathname.match(Studentcurriculumstop.RoutePathname)) {
        if (this._doLoadingPageDataInDidMount) {
          this._doLoadingPageDataInDidMount = false;
          this._loadPageData();
        } else {
          return;
        }
      }
    }, 1);
  }

  async _loadPageData() {
    // VALIDATE INPUT
    // @ts-ignore
    const id = this.props.match.params.id;
    if (!id) {
      return; //ERROR INPUTS
    }

    // WAITING SCREEN
    StaticEvent.LoadingEvent.next(true);

    // POST
    let postData = {
      p1: id,
      timezoneOffset: (new Date()).getTimezoneOffset() * 60 * 1000,
    };
    const postUrl = ApiService.urlMapping('~/api/1/studentcurriculumstop');
    Static.apiService
      .post(postUrl, postData)
      .subscribe(async (res: any) => {
          // CLOSE WAITING SCREEN
          StaticEvent.LoadingEvent.next(false);

          let data = res.data;
          _.debugManager.log(data);

          let error = data.error || null;
          let result = error == null;

          if (result) { // SUCEESS

            let payload = data.payload;
            _.debugManager.log(payload);

            this.loadPageData_OnlyOnceGuard = true;

            // @ts-ignore
            await this.setState({
              pageData: payload,
            });
            await this.setState({
              Item_對象: this.state.pageData.Item_對象
            });

          } else {
            // AUTH USER EXPIRED
            if (error.code == 2) {
              alert('帳號被登出，請重新登入');
              window.location.href = '/login';
              //this.props.history.push('/login')
              return;
            }

            alert(error.message);
          }
        }, async (err) => {
          // CLOSE WAITING SCREEN
          StaticEvent.LoadingEvent.next(false);
          _.debugManager.warn(err);
          alert('網路連線有問題');
        }
      );
  }

  handleInputChange(e) {
    let newItem = Object.assign({}, this.state.Item_對象, {
      [e.target.name]: e.target.value,
    });

    // @ts-ignore
    this.setState({
      Item_對象: newItem,
    });
  }

  // 驗證函式
    validateRequiredField(value: any, fieldName: string): string | null {
      if (!value || (typeof value === "string" && value.trim() === "")) {
        return `${fieldName}`;
      }
      return null;
    }


  async handleSaveSubmit(e: any) {
    e.preventDefault();

    const { 課程中止時間, 課程中止原因 } = this.state.Item_對象;

    let errorMessage =
      this.validateRequiredField(課程中止時間, "請先選擇中止日期") ||
      this.validateRequiredField(課程中止原因, "請填寫說明中止原因");

    if (errorMessage) {
      alert(errorMessage);
      return;
    }

    // WAITING SCREEN
    StaticEvent.LoadingEvent.next(true);

    // POST
    let postData = {
      p1: this.state.Item_對象,
      timezoneOffset: (new Date()).getTimezoneOffset() * 60 * 1000,
    };
    const postUrl = ApiService.urlMapping('~/api/1/_studentcurriculumstop');
    Static.apiService
      .post(postUrl, postData)
      .subscribe(async (res) => {
          // CLOSE WAITING SCREEN
          StaticEvent.LoadingEvent.next(false);

          let data = res.data;
          _.debugManager.log(data);

          let error = data.error || null;
          let result = error == null;

          if (result) { // SUCEESS
            this.props.history.goBack();
            //await this._loadPageData();


          } else {
            alert(error.message);
            // const controller: any = document.querySelector('ion-toast-controller');
            // let msg = await controller.create({
            //   message: error.message,
            //   duration: 2000,
            //   position: 'top'
            // });
            // await msg.present();
          }
        }, async (err) => {
          // CLOSE WAITING SCREEN
          StaticEvent.LoadingEvent.next(false);
          _.debugManager.warn(err);
          alert('網路連線有問題');
        }
      );
  }


  presentPopover = (e: MouseEvent) => {
    this.setState(() => ({
      showPopover: true,
      showPopoverEvent: e
    }));
  };
  ㄙ

  dismissPopover = () => {
    this.setState(() => ({
      'showPopover': false,
      'showPopoverEvent': null
    }));
  };

  render() {
    let selectyear = String((new Date().getFullYear()) + 1);

    return (
      <>


        <IonHeader>
          <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonBackButton defaultHref="/" onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                this.props.history.goBack();
              }} text="返回"/>
            </IonButtons>
            <IonTitle>課程中止</IonTitle>
            {this.state.pageData &&
              <IonButtons slot="end">
                <IonButton onClick={e => this.handleSaveSubmit(e)}>
                  儲存
                </IonButton>
              </IonButtons>
            }
          </IonToolbar>
        </IonHeader>

        <IonContent scroll-y="false">
          <form noValidate>
            <IonList>
              <IonItem>
                <IonIcon icon={calendar} slot="start" color="danger"></IonIcon>
                <IonLabel>中止日期</IonLabel>
                <IonDatetime
                  name="課程中止時間"
                  value={this.state.Item_對象.課程中止時間}
                  onIonChange={(e: any) => this.handleInputChange(e)}

                  min="1990-02"
                  max={selectyear}
                  displayFormat="YYYY/MM/DD" placeholder="請選擇日期" done-text="確定" cancel-text="取消"></IonDatetime>
              </IonItem>
              <IonItem>
                <IonLabel position="stacked">中止因素 <span>*</span></IonLabel>
                <IonTextarea
                  name="課程中止原因"
                  value={this.state.Item_對象.課程中止原因}
                  onIonChange={(e: any) => this.handleInputChange(e)}

                  required rows={6}
                  placeholder="請輸入說明"></IonTextarea>
              </IonItem>
            </IonList>
          </form>
          <p className="info">若此對象需要重新開始對課，請聯繫懷相福音事工中心</p>
        </IonContent>
      </>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  conferenceDate: selectors.sessions.conferenceStart(state.sessions),
  isAuthenticated: state.user.isAuthenticated
});

export default connect(
  mapStateToProps
)(Studentcurriculumstop);
